import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ReportDetailsByJurisdiction } from 'src/app/v2/models';
import { Router } from '@angular/router';
import { prefix, REPORT_TYPES } from 'src/app/v2/constants';
import { ComplianceCentralService } from 'src/app/v2/services';
import { ReportFileTypesConstants } from 'src/app/shared/constants';

@Component({
  selector: 'compliance-central-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class ComplianceCentralDetailComponent implements OnInit {
  @Input() reports: ReportDetailsByJurisdiction[] = [];
  @Input() reportMeta: any = null;
  @Output() onClose = new EventEmitter();
  @Input() showOptions: boolean;
  @Input() activeReportType: any;
  @Input() reportType: string;

  views = [{
    id: 'grid',
    isActive: true,
    name: 'Card View',
    src: 'legacy/assets/img/v2-icons/Grid.svg',
    style: {
      position: 'relative',
      top: '-1px'
    }
  }, {
    id: 'list',
    src: 'legacy/assets/img/v2-icons/List.svg',
    name: 'List View'
  }];

  constructor(private _router: Router,
    public service: ComplianceCentralService) { }

  ngOnInit() {}

  downloadReport({ report }) {
    let downloadFileSuffix = '';
    if (this.reportType === REPORT_TYPES.masterFile) {
      downloadFileSuffix = ReportFileTypesConstants.MASTER_FILE_REPORT;
    } else if (this.reportType === REPORT_TYPES.localFile && report.templateId) {
      downloadFileSuffix = report.templateId.includes(ReportFileTypesConstants.ANALYSIS_BENCHMARK_REPORT) ? ReportFileTypesConstants.BENCHMARK_REPORT : ReportFileTypesConstants.LOCAL_FILE_REPORT;
    }
    const downloadFileName = `${report.reportName} ${downloadFileSuffix}`;
    this.service.getSignedDownloadURL(report.reportInstanceBinaryPath, downloadFileName);
  }

  handleOptionClick(event) {
    this._router.navigate([`/${prefix}/entity/${event.report.localEntityId}/${event.event}`]);
  }
}
